export default __webpack_public_path__ + "static/media/details.63ae0bde.svg";